import React from 'react';
import { LucideIcon } from 'lucide-react';
import './FormSectionHeader.css';

interface FormSectionHeaderProps {
  icon: LucideIcon;
  title: string;
  subtitle?: string;
}

const FormSectionHeader: React.FC<FormSectionHeaderProps> = ({ icon: Icon, title, subtitle }) => {
  return (
    <h2 className="form-section-header">
      <Icon size={24} />
      <span className="form-section-header-text">
        {title}
        {subtitle && <small className="readonly-note">{subtitle}</small>}
      </span>
    </h2>
  );
};

export default FormSectionHeader;
